import { createElement, useEffect } from "react";
import { useLocation } from "wouter";
import {
  ELEVENLABS_AGENT_ID,
  ELEVENLABS_WIDGET_SCRIPT,
  shouldLoadElevenLabsWidget,
} from "@shared/elevenlabsWidget";

const SCRIPT_SELECTOR = "script[data-structura-elevenlabs-widget]";

export function ElevenLabsWidgetGate() {
  const [location] = useLocation();
  const enabled = shouldLoadElevenLabsWidget(location);

  useEffect(() => {
    if (!enabled) return;

    let script = document.querySelector<HTMLScriptElement>(SCRIPT_SELECTOR);
    let ownsScript = false;

    if (!script) {
      script = document.createElement("script");
      script.src = ELEVENLABS_WIDGET_SCRIPT;
      script.async = true;
      script.type = "text/javascript";
      script.dataset.structuraElevenlabsWidget = "true";
      document.body.appendChild(script);
      ownsScript = true;
    }

    return () => {
      if (ownsScript) script?.remove();
    };
  }, [enabled]);

  if (!enabled) return null;

  return createElement("elevenlabs-convai", {
    "agent-id": ELEVENLABS_AGENT_ID,
    dismissible: "true",
    "action-text": "Talk to Structura",
    "expand-text": "Open chat",
    "collapse-text": "Close chat",
    "data-structura-elevenlabs-widget": "true",
  });
}
